import { render, staticRenderFns } from "./MoveTransactionToSaving.vue?vue&type=template&id=d8fedce4&scoped=true"
import script from "./MoveTransactionToSaving.vue?vue&type=script&lang=js"
export * from "./MoveTransactionToSaving.vue?vue&type=script&lang=js"
import style0 from "./MoveTransactionToSaving.vue?vue&type=style&index=0&id=d8fedce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fedce4",
  null
  
)

export default component.exports